import { BusinessReportDetails } from 'core/empresa/components/BusinessReportDetails/BusinessReportDetails';
import { BusinessReportTable } from 'core/empresa/components/BusinessReportTable/BusinessReportTable';
import { BusinessTotalsReportContext } from 'core/empresa/contexts/BusinessTotalsReportContext';
import { useContext } from 'react';
import { LinkButton } from 'shared/components';
import { Col, Container, Row } from 'react-bootstrap';

export const BusinessTotalsReportPage = () => {
  const { consolidatedReport, goHome } = useContext(BusinessTotalsReportContext);
  return (
    <Container>
      <Row className="mb-3">
        <Col>
          <BusinessReportDetails
            denominacionEmpresa={consolidatedReport?.denominacionEmpresa}
          />
        </Col>
      </Row>
      <BusinessReportTable reporte={consolidatedReport} />

      <Row className="text-center">
        <Col>
          <LinkButton onClick={goHome}>Volver</LinkButton>
        </Col>
      </Row>
    </Container>
  );
};
